/**
 * Controls the behavior of the Mobile Main Navigation, including showing and hiding the submenus
 *
 * @type {Helpers}
 * @class
 */
export class Helpers {
    /**
     * Hide a submenu inside the mobile menu
     *
     * @param {Element} mobileSubCloser - The element which has been clicked
     *
     * @returns {undefined}
     */

    static isOnMobile() {
        let windowWidth = window.innerWidth
        return windowWidth <= 992
    }

    static dynamicMenuWidth() {
        // get the sum of the width of all menu elements
        const menuItems = Array.from(document.querySelectorAll('.js-main-nav__list-item-1'))
        let menuWidth = menuItems.reduce(function (sum, menuItem) {
            return sum + menuItem.clientWidth
        }, 0)

        // Add padding left and right
        const paddingLeft = 16
        const paddingRight = 16 + 90
        menuWidth += paddingLeft + paddingRight

        // Set the width on all menus
        Array.from(document.querySelectorAll('.js__main-nav__sub')).forEach((el) => (el.style.width = menuWidth + 'px'))
    }
}
